module.exports = __webpack_public_path__ + "static/media/cover.61105d82.jpg";